import { ApiMethod } from '@wajeez-web/stores/base';
import { AlertType, CommonActions } from '@wajeez-web/stores/common';
import { paymentClient, Server } from '@wajeez-web/core/api-base';

export const getPromoCodesLookups: ApiMethod<
  void,
  Server.PromoCodeOutput[],
  void
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_PromoCode_Client(undefined, paymentClient);

    const response = await client.promoCode_get_V1();

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};

export const getPromoCodesDatatable: ApiMethod<
  Server.GetPromoCodeDatatableInput,
  Server.TableOfPromoCodeColumns,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_PromoCode_Client(undefined, paymentClient);

    const response = await client.promoCode_datatable_post_V1(data);

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};

export const createPromoCode: ApiMethod<
  { code: string | undefined; expiresOn?: string },
  Server.PromoCodeOutput,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_PromoCode_Client(undefined, paymentClient);

    const response = await client.promoCode_post_V1(data.code, data.expiresOn);

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};

export const editPromoCode: ApiMethod<
  Server.UpdatePromoCodeInput,
  void,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_PromoCode_Client(undefined, paymentClient);

    const response = await client.promoCode_put_V1(data);

    if (response.success) {
      return;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};

export const assignPromoCodeToProductGroup: ApiMethod<
  Server.AssignPromoCodeToProductGroupInput,
  void,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_PromoCode_Client(undefined, paymentClient);

    const response = await client.promoCode_assignProductGroup_post_V1(data);

    if (response.success) {
      return;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};

export const getPromoCodeById: ApiMethod<
  number,
  Server.PromoCodeOutput,
  void
> = async (id, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_PromoCode_Client(undefined, paymentClient);

    const response = await client.promoCode_byId_get_V1(id);

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};
